/* eslint-disable @typescript-eslint/no-empty-function */
import Icon from '@mercadoni/sinister/dist/cjs/Icon'
import { CategoryTree } from '@mercadoni/sinister/dist/cjs/categoryTree'
import { CategoryModel } from '@mercadoni/sinister/dist/lib/src/entities/category'
import { CategoryTree as ICategoryTree } from '@mercadoni/sinister/dist/lib/src/entities/clientModel'
import { FC, useState } from 'react'
import styled from 'styled-components'
import { Store } from '~types/index'
import Text from './decorators/Text'

const StyledButton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px;
  gap: 4px;
  border-radius: 100px;
  border: none;
  color: var(--app-header-color-desktop-v3, var(--color-white));
  cursor: pointer;
  position: relative;
  ${({ isLightBackground }: { isLightBackground: boolean }) =>
    isLightBackground
      ? `background-color: #f2f2f2;`
      : `background-color: var(--app-header-background-desktop-v3); background-image: var(--app-header-overlay-desktop-v3);`}
`

const StyledButtonMobile = styled(StyledButton)`
  background-color: transparent;
  gap: 0;
  border-radius: 0;
  padding: 0;
  background-image: none;
  color: var(--app-header-color-mobile-v3, var(--color-white));
`

const modalStyles = `
  &.ant-modal {
    top: 92px;
    left: min(180px, 15vw);
  }
`

interface CategoriesLayoutProps {
  clientId: string
  clientCategoryTree: ICategoryTree
  className?: string
  initialCategories?: CategoryModel[]
  onCategoryOnClick: () => void
  onPromotionsOnClick: () => void
  store: Store
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  copies: any
  isLightBackground: boolean
  isMobile: boolean
}

const CategoriesLayout: FC<CategoriesLayoutProps> = (props) => {
  const {
    clientId,
    clientCategoryTree,
    className,
    initialCategories,
    onCategoryOnClick,
    onPromotionsOnClick,
    store,
    copies,
    isLightBackground,
    isMobile,
  } = props
  const [openCategoryTree, setOpenCategoryTree] = useState(() => () => {})
  const { header: copy } = copies

  const ActionButton = isMobile ? StyledButtonMobile : StyledButton
  return (
    <>
      <CategoryTree
        clientId={clientId}
        storeReference={store.reference}
        copies={copies}
        onCategoryOnClick={onCategoryOnClick}
        onPromotionsOnClick={onPromotionsOnClick}
        setOpenCategoryTree={setOpenCategoryTree}
        {...clientCategoryTree}
        modalStyles={modalStyles}
        initialCategories={initialCategories}
      />
      <ActionButton
        onClick={() => openCategoryTree()}
        className={className}
        isLightBackground={isLightBackground || false}
      >
        <Icon className="ph-squares-four" size={24} aria-label="Categories" />
        {!isMobile && <Text text={copy?.categories} />}
      </ActionButton>
    </>
  )
}

export default CategoriesLayout
